var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankId = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank-ID-Sign-test-icon@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bank-ID-Sign-test-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "BID",
    transform: "translate(6.000000, 10.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42838,2.24112 C3.69518,2.32560667 3.90417333,2.46678833 4.05536,2.664665 C4.20654667,2.86254167 4.28214,3.10599667 4.28214,3.39503 C4.28214,3.80412333 4.12317167,4.118725 3.805235,4.338835 C3.48729833,4.558945 3.02373333,4.669 2.41454,4.669 L0,4.669 L0,0 L2.28114,0 C2.85031333,0 3.28719833,0.108943333 3.591795,0.32683 C3.89639167,0.544716667 4.04869,0.84042 4.04869,1.21394 C4.04869,1.44072 3.99421833,1.64304333 3.885275,1.82091 C3.77633167,1.99877667 3.62403333,2.13884667 3.42838,2.24112 Z M1.07387,0.81374 L1.07387,1.91429 L2.14774,1.91429 C2.41454,1.91429 2.61686333,1.8676 2.75471,1.77422 C2.89255667,1.68084 2.96148,1.54299333 2.96148,1.36068 C2.96148,1.17836667 2.89255667,1.04163167 2.75471,0.950475 C2.61686333,0.859318333 2.41454,0.81374 2.14774,0.81374 L1.07387,0.81374 Z M2.3345,3.85526 C2.61908667,3.85526 2.83363833,3.80857 2.978155,3.71519 C3.12267167,3.62181 3.19493,3.47729333 3.19493,3.28164 C3.19493,2.89478 2.90812,2.70135 2.3345,2.70135 L1.07387,2.70135 L1.07387,3.85526 L2.3345,3.85526 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.3109875 0 6.3915275 0 6.3915275 4.669 5.3109875 4.669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.707185,0 L9.828245,0 C10.335165,0 10.7831667,0.096715 11.17225,0.290145 C11.5613333,0.483575 11.8637067,0.755933333 12.07937,1.10722 C12.2950333,1.45850667 12.402865,1.8676 12.402865,2.3345 C12.402865,2.8014 12.2950333,3.21049333 12.07937,3.56178 C11.8637067,3.91306667 11.5613333,4.185425 11.17225,4.378855 C10.7831667,4.572285 10.335165,4.669 9.828245,4.669 L7.707185,4.669 L7.707185,0 Z M9.774885,3.78189 C10.241785,3.78189 10.6141933,3.651825 10.89211,3.391695 C11.1700267,3.131565 11.308985,2.77916667 11.308985,2.3345 C11.308985,1.88983333 11.1700267,1.537435 10.89211,1.277305 C10.6141933,1.017175 10.241785,0.88711 9.774885,0.88711 L8.787725,0.88711 L8.787725,3.78189 L9.774885,3.78189 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankId);
export { ForwardRef as ReactComponent };